import { gql } from '@apollo/client'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import type { FulfillWorkOrderArgs, WorkOrder } from '@ztechapps/common.contract'

export const fulfillWorkOrderQuery = gql`
  mutation fulfillWorkOrder($input: FulfillWorkOrderArgs!) {
    fulfillWorkOrder(input: $input) {
      _id
      inventoryBySerialNumbers {
        _id
        code
        status
        order {
          _id
          code
        }
      }
      status
    }
  }
`

export const useFulfillWorkOrder = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, FulfillWorkOrderArgs> => {
  query = query ?? fulfillWorkOrderQuery

  return useActionMutation({
    query,
    ...props,
  })
}
